<template>
  <div class="gongde-box-container">
    <div class="box-border">
      <div class="header">
        <div class="back-btn" @click="handleBack">
          <img src="https://fe-img.tengzhihh.com/image/bcef926966c12975fbb7e54c43d4cdeb-60x60.png" alt="" />
        </div>
        <div class="title">{{ $route.meta.title }}</div>
        <div class="explain" @click="handleGuide(false)">说明</div>
      </div>

      <div class="main">
        <div class="box">
          <img src="https://fe-img.tengzhihh.com/image/e35dd8dd5ed1ca22a789fab082456f54-507x507.png" alt="" />
        </div>
        <template v-if="serial_id">
          <div class="btns" v-if="goodsDetail.goods && goodsDetail.goods.sku.length">
            <div
              class="btn-item"
              :class="{ active: skuPrice === item.price }"
              v-for="item in goodsDetail.goods.sku"
              :key="item.id"
              @click="handleSku(item)"
            >
              <img
                class="lianhua"
                src="https://fe-img.tengzhihh.com/image/9805c7dd77e948d94895b3d1fc1687a6-49x49.png"
                alt=""
              />
              <div class="gongde">{{ item.fu_de }}功德值</div>
              <div class="price">￥{{ item.price }}</div>
            </div>
          </div>
          <div class="input">
            <div>自定义金额：</div>
            <div><input type="text" inputmode="numeric" v-model.trim="customPrice" @input="handleInput" />&nbsp;元</div>
            <div>（&nbsp;{{ gongde }}&nbsp;功德值）</div>
          </div>
          <div class="submit" @click="handleSubmit">布施</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import apiPath from '@/utils/apiPath';
import { numMul } from '@/utils/math';
import { orderDetail } from '@/api/order';

export default {
  name: 'gongde-box-index',
  data() {
    return {
      goods_id: 10014,
      serial_id: this.$route.query.serial_id,
      skuPrice: '',
      customPrice: '',
      goodsDetail: {},
      tipsShow: !localStorage.getItem('gongdeBoxTips'),
    };
  },
  computed: {
    gongde() {
      let num = this.customPrice || this.skuPrice;
      return num ? numMul(num, 7) : 0;
    },
    returnUrl: function () {
      const mainUrl = location.origin;
      return `${mainUrl}/gongdebox/paySuccess`;
    },
  },
  mounted() {
    this.getDetails();
    if (this.$route.query.order_id) {
      this.orderTips(this.$route.query.order_id);
    }
  },
  methods: {
    getDetails() {
      this.$http
        .get(apiPath.goodsDetail, {
          goods_id: this.goods_id,
          serial_id: this.serial_id,
          ver: '1.3',
        })
        .then(res => {
          this.skuPrice = res.data.goods.sku[res.data.goods.sku.length - 1].price;
          this.goodsDetail = res.data;
        });
    },
    handleSku(item) {
      this.customPrice = '';
      this.skuPrice = item.price;
    },
    handleInput() {
      this.skuPrice = '';
      // 获取输入值并处理
      let value = this.customPrice;
      // 过滤掉非数字字符
      value = value.toString().replace(/[^\d]/g, '');
      // 限制长度为5位
      value = value.slice(0, 5);
      // 处理前导零
      if (value.length > 1) {
        value = value.replace(/^0+/, '');
      }
      this.customPrice = value;
    },
    handleGuide(tipsClose = true) {
      if (tipsClose) {
        localStorage.setItem('gongdeBoxTips', '1');
      } else {
        this.$router.push({
          name: 'gongde-box-guide',
        });
      }
    },
    handleBack() {
      this.$router.replace({
        path: '/device/index',
        query: {
          serial_id: this.serial_id,
        },
      });
    },
    handleSubmit() {
      if ((this.customPrice && this.customPrice > 0) || this.skuPrice) {
        this.onOrder();
      } else {
        this.$toast('请输入金额或选择功德值');
      }
    },
    onOrder() {
      let data = {
        goods_id: this.goods_id,
        serial_id: this.serial_id,
        ver: '1.3',
        amount: Number(this.customPrice || this.skuPrice),
        platform: 'web',
        return_url: this.returnUrl,
        fu_de: this.gongde,
      };

      this.$toast.loading('支付中...');
      this.$http.post(apiPath.createGongdeOrder, data).then(res => {
        this.$toast.clear();
        if (res.code === 0) {
          const {
            default: defaultUrl,
            order_center_id,
            ali_pay_channel,
            wechatv3_official,
            wechat_office_pay_channel,
          } = res.data;
          if (this.$tools.isWeChat()) {
            location.href = `https://${wechatv3_official}/pay?order_id=${order_center_id}&channel_id=${wechat_office_pay_channel}`;
          } else {
            location.href = `https://${defaultUrl}/pay?order_id=${order_center_id}&channel_id=${ali_pay_channel}`;
          }
        } else {
          this.$toast(res.msg);
        }
      });
    },
    async orderTips(order_id) {
      const res = await orderDetail({ order_id });
      if (res.code === 0) {
        if (res.data.order.status === 6) {
          this.$toast({ message: `随喜功德，功德值+${numMul(res.data.order.amount, 7)}`, duration: 5000 });
        }
      } else {
        this.$toast(res.msg);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.gongde-box-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #fcf5ec;
  background-image: url('https://fe-img.tengzhihh.com/image/54c89981c5251e5cd8996007d316e476-800x1280.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 10px 9px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 18px;
    margin-bottom: 32px;

    .back-btn {
      img {
        user-select: none;
        width: 30px;
        height: 30px;
      }
    }
    .title {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-size: 16px;
      color: #7b5439;
      line-height: 20px;
    }
    .explain {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-size: 14px;
      color: #7b5439;
      line-height: 20px;
    }
  }

  .main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .box {
      margin-bottom: 38px;
      img {
        user-select: none;
        width: 253.5px;
        height: 253.5px;
      }
    }

    .btns {
      width: 100%;
      display: flex;
      padding: 0 15px;
      box-sizing: border-box;
      justify-content: space-evenly;
      gap: 10px;
      margin-bottom: 31px;

      .btn-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 33.3%;
        min-height: 74.5px;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 9px 9px 9px 9px;
        border: 1.5px solid rgba(248, 122, 27, 0.35);

        &.active {
          border-color: #f87a1b;
        }

        .lianhua {
          width: 25.5px;
          user-select: none;
        }

        .gongde {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: bold;
          font-size: 13.5px;
          color: rgba(133, 83, 31, 0.85);
          line-height: 20px;
        }
        .price {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 13.5px;
          color: rgba(151, 108, 63, 0.65);
          line-height: 20px;
        }
      }
    }
    .input {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 13.5px;
      color: #7b5439;
      line-height: 18px;
      margin-bottom: 43.5px;
      padding: 0 15px;

      input {
        width: 96px;
        background-color: transparent;
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: 1px solid #7b5439;
        text-align: center;
      }
    }

    .submit {
      width: 198px;
      height: 38.5px;
      background: #f87a1b;
      border-radius: 8.5px;
      text-align: center;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 11.5px;
      color: #ffffff;
      line-height: 38.5px;
      margin-bottom: 30px;
    }
  }

  .van-popup {
    background-color: transparent;
  }

  .tips-content {
    position: relative;
    background-image: url('https://fe-img.tengzhihh.com/image/f686ad355a0e82b311cc05dd9afddd58-560x585.png');
    background-size: 100% 100%;
    width: 269px;
    height: 281px;

    .btn-placeholder {
      position: absolute;
      bottom: 19px;
      left: 50%;
      transform: translateX(-50%);
      width: 199px;
      height: 39px;
      border-radius: 8.5px;
    }
  }

  .box-border {
    border-radius: 5px 5px 5px 5px;
    border: 1.5px solid #bf4636;
    height: 100%;
    width: 100%;
    overflow: auto;
    box-sizing: border-box;
  }
}
</style>
